import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import './styles.scss'

export interface Props {
  img: string
  url: string
  linktext: React.ReactNode
  tracking: boolean
}

export const ArticlePromotionBox = ({
  img,
  url,
  linktext,
  tracking = true
}: Props) => {
  if (!img || img === '') {
    throw new Error('ArticlePromotionBox > Image-Url is required!')
  }
  if (!url || url === '') {
    throw new Error('ArticlePromotionBox > Link-Url is required!')
  }
  const trackClick = () => {
    if (tracking) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'Link Click Element',
        eventAction: '/',
        eventLabel: url
      })
    }
    window.open(url, '_self')
  }
  return (
    <main className='ui vertical fitted segment articlePromotionBox' id='teil1'>
      <div className='ui text container ' onClick={trackClick}>
        <div className='linkimage'>
          {' '}
          <img src={img} className='ui fluid image' />{' '}
        </div>
        <div className='linktext'>{linktext}</div>
        {/**/}
      </div>
    </main>
  )
}
